define("shared/utils/build-error-message", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = buildErrorMessage;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  function buildErrorMessage(intl, error) {
    let defaultErrorMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'alerts.generic_error_message';
    /**
     * Given any error, finds the best way to display the error message to the user.
     * Handles cases where there are multiple error messages by concatening them
     *
     * @method buildErrorMessage
     * @param {Error} error An Error object
     * @param {String} [defaultErrorMessage] The error message to use should the handler be unable to find a more specific error.
     * Falls back to a generic error message
     *
     * @returns {Object<String} The error message for the provided error.
     */

    if (!error) {
      return intl.t(defaultErrorMessage);
    }
    if (typeof error === 'string') {
      return error;
    }
    if (error?.payload?.errors?.length) {
      const {
        errors
      } = error.payload;
      if (errors.length === 1) {
        return errors[0].detail || errors[0].title;
      }
      return intl.t('account.error.multiple_errors', {
        errors: errors.map(error => errors.detail || error.title).join(', ')
      });
    }
    if (error?.errors?.length) {
      const {
        errors
      } = error;
      if (errors.length === 1) {
        return errors[0].detail || errors[0].title;
      }
      return intl.t('account.error.multiple_errors', {
        errors: errors.map(error => error.detail || error.title).join(', ')
      });
    }
    if (error?.message) {
      return error.message;
    }
  }
});